var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackStepsBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 80,
    viewBox: "0 0 235 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 25,
    transform: "matrix(1 0 0 -1 -0.000244141 25.9961)",
    fill: "#292B33"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 233,
    height: 25,
    transform: "matrix(1 0 0 -1 -0.000244141 53)",
    fill: "#292B33"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 214,
    height: 25,
    transform: "matrix(1 0 0 -1 -0.000244141 80)",
    fill: "#292B33"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 79.9961,
    width: 25,
    height: 1.00001,
    transform: "rotate(-90 234 79.9961)",
    fill: "#292B33"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 79.9961,
    width: 25,
    height: 1.00001,
    transform: "rotate(-90 215 79.9961)",
    fill: "#292B33"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 79.9961,
    width: 25,
    height: 1.00001,
    transform: "rotate(-90 230 79.9961)",
    fill: "#292B33"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 79.9961,
    width: 25,
    height: 2.00001,
    transform: "rotate(-90 217 79.9961)",
    fill: "#292B33"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 79.9961,
    width: 25,
    height: 3.00001,
    transform: "rotate(-90 222 79.9961)",
    fill: "#292B33"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 79.9961,
    width: 25,
    height: 1.00001,
    transform: "rotate(-90 226 79.9961)",
    fill: "#292B33"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackStepsBg);
export default __webpack_public_path__ + "static/media/black-steps-bg.73562b01efb78cf69d142b49fc130a03.svg";
export { ForwardRef as ReactComponent };